'use client';

export type ConsentCategories = {
  functionality: 'granted' | 'denied';
  analytics: 'granted' | 'denied';
  ads: 'granted' | 'denied';
};

export type GoogleConsentParams = {
  ad_storage: 'granted' | 'denied';
  analytics_storage: 'granted' | 'denied';
  functionality_storage: 'granted' | 'denied';
  ad_user_data: 'granted' | 'denied';
  ad_personalization: 'granted' | 'denied';
};

/**
 * Maps our simplified consent categories to Google's detailed consent parameters
 */
export function mapConsentCategoriesToGoogle(
  categories: ConsentCategories,
): GoogleConsentParams {
  return {
    functionality_storage: categories.functionality,
    analytics_storage: categories.analytics,
    ad_storage: categories.ads,
    ad_user_data: categories.ads,
    ad_personalization: categories.ads,
  };
}

/**
 * Type-safe wrapper around window.gtag
 */
export function gtag(...args: unknown[]) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
}

/**
 * Set default consent state (should be called before GTM loads)
 */
export function setDefaultConsent(categories: ConsentCategories) {
  const googleParams = mapConsentCategoriesToGoogle(categories);
  gtag('consent', 'default', googleParams);
}

/**
 * Update consent state after user interaction
 */
export function updateConsent(categories: ConsentCategories) {
  const googleParams = mapConsentCategoriesToGoogle(categories);
  gtag('consent', 'update', googleParams);
}

/**
 * Send a custom event to GTM
 */
export function trackEvent(
  eventName: string,
  eventParameters: Record<string, unknown> = {},
) {
  gtag('event', eventName, eventParameters);
}
